module.exports = __webpack_public_path__ + "/login_ui/img/is-093de0f49f59a46f01d462f73fd4d49a.svg";